import { z } from "zod";

export const BannerSchema = z.object({
    image: z.string(),
    mini_image_link: z.string(),
    link: z.string().optional().nullable(),
    title: z.string().optional().nullable(),
    dominant_color: z.string().optional().nullable()
})

export const BannerServerResponseSchema = z.array(BannerSchema);

export type BannerType = z.infer<typeof BannerSchema>;
export type BannerServerResponseType = z.infer<typeof BannerServerResponseSchema>